import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import FlowCanvas from './components/FlowCanvas';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import { ApiProvider } from './hooks/useApi';
import { FlowProvider } from './hooks/useFlowContext';
import AuthProvider from './contexts/AuthContext';
import './index.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ApiProvider>
          <FlowProvider>
            <Routes>
              <Route
                path="/"
                element={
                  <div className="min-h-screen bg-gradient-to-br from-bible-cream to-gray-100 overflow-hidden overflow-x-hidden">
                    <FlowCanvas />
                  </div>
                }
              />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
            </Routes>
          </FlowProvider>
        </ApiProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;